.a3{justify-content:center;}